const state = {
    tourHistory: JSON.parse(localStorage.getItem('tourHistory') ?? "[]")
}

const getters = {
    tourHistory: state => state.tourHistory
}

const actions = {
    setTourHistory({commit}, tourHistory) {
        commit('saveTourHistory', tourHistory);
    },

    resetTourHistory({commit}) {
        commit('clearTourHistory');
    }
}

const mutations = {
    saveTourHistory(state, tourHistory){
        localStorage.setItem('tourHistory',JSON.stringify(tourHistory))
        state.tourHistory = tourHistory;
    },

    clearTourHistory(state) {
        localStorage.removeItem("tourHistory");
        state.tourHistory = [];
    }
}

export default {
    state, 
    getters,
    actions,
    mutations
}